<mat-toolbar class="toolbar-sm">
    <img src="app/assets/images/expand-rows-down.png" width="16" height="16" id="expandRowsDown"
        matTooltip="{{engLang ? 'Expand All Claims' : 'Expandir todos los casos'}}" matTooltipPosition="above"
        (click)="onClick_menu($event)" style="cursor: pointer;">

    <img src="app/assets/images/collapse-rows-up.png" width="16" height="16" id="collapseRowsUp"
        matTooltip="{{engLang ? 'Collapse All Claims' : 'Colapsar todos los casos'}}" matTooltipPosition="above"
        (click)="onClick_menu($event)" style="cursor: pointer;">

    <i class="fa fa-trash font12" id="delete" matTooltip="{{ engLang ? 'Delete Report': 'Eliminar Reporte' }}"
        matTooltipPosition="above" (click)=" onClick_menu($event)" style="cursor: pointer;"></i>

    <i class="far fa-file-excel font13" matTooltipPosition="above" id="exportToExcel" matTooltip="Excel"
        (click)="onClick_menu($event)" style="cursor: pointer;"></i>

    <mat-icon class="font15 pt-1" matTooltip="{{engLang ? 'Print' : 'Imprimir'}}" matTooltipPosition="above"
        (click)="onClick_menu($event)" id="print" style="cursor: pointer;">print</mat-icon>
</mat-toolbar>

<mat-form-field style="height: 75px; min-height: 75px; width: 100%;">
    <mat-label class="font13">{{engLang ? 'Select from past reports' : 'Seleccione de reportes
        pasados'}}</mat-label>
    <mat-select (selectionChange)="onChange_view($event.value)" class="text-center" style="font-size: 14px;">
        <mat-option *ngFor="let v of views()" [value]="v.name">
            <span style="font-size: 13px;">{{engDtxDescr(v.name)}}</span>
        </mat-option>
    </mat-select>
</mat-form-field>

<div class="mat-table-wrapper">
    <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortea($event)" class="mat-elevation-z8"
        multiTemplateDataRows>

        <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->

        <!-- Alternative hack to cause clm() to propagate changes to dataSource -->
        <!-- <div *ngIf="clm().length >= 0"></div> -->

        <!-- <ng-container matColumnDef="index">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center font12"> Number </th>
            <td mat-cell *matCellDef="let clm" class="font10" (click)="onClick_expandDet(clm.CasID)">
                {{clm.index}} </td>
        </ng-container> -->

        <ng-container matColumnDef="PatLastNm">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center font12"> {{engLang ? 'Last
                Name':
                'Apellidos'}} </th>
            <td mat-cell *matCellDef="let clm" class="font10" (click)="onClick_expandDet(clm.CasID)">
                {{clm.PatLastNm}} </td>
        </ng-container>

        <ng-container matColumnDef="PatFstNm">
            <th mat-header-cell *matHeaderCellDef class="font12"> {{engLang ? 'Name': 'Nombre'}} </th>
            <td mat-cell *matCellDef="let clm" class="font10" (click)="onClick_expandDet(clm.CasID)">
                {{clm.PatFstNm}} </td>
        </ng-container>

        <ng-container matColumnDef="caseNo">
            <th mat-header-cell *matHeaderCellDef class="text-center font12"> {{engLang ? 'Clain #': '# Caso'}}
            </th>
            <td mat-cell *matCellDef="let clm" class="text-center">
                <button mat-button class="link-button font12"
                    (click)="xtPID = clm.CasPatID; xtCID = clm.CasID;
                patNmModalHd = clm.PatLastNm + ', ' + clm.PatFstNm;
                casNoModalHd = clm.caseNo;
                open(recordCaseModal, { backdrop: 'static', size: 'lg', scrollable: true }, 'recordCaseModal', $event);">
                    {{removeLocaleLeadZeros(clm.caseNo)}}
                </button>
            </td>
        </ng-container>

        <ng-container matColumnDef="ins1">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center font12"> Plan 1/2 </th>
            <td mat-cell *matCellDef="let clm" class="font9" (click)="onClick_expandDet(clm.CasID)">
                <span matTooltip="{{clm.ins1}}" matTooltipPosition="above">{{truncateString(clm.ins1,20)}}</span> <br>
                <span matTooltip="{{clm.ins2}}" matTooltipPosition="below">{{truncateString(clm.ins2,20)}}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="totPvdo">
            <th mat-header-cell *matHeaderCellDef class="rtalign font12"> {{engLang ? 'Patient': 'Privado'}} </th>
            <td mat-cell *matCellDef="let clm" class="rtalign font10" (click)="onClick_expandDet(clm.CasID)">
                {{makeNum(clm.totPvdo) | currency:'USD':'':'0.2-2'}} </td>
        </ng-container>

        <ng-container matColumnDef="totPayed">
            <th mat-header-cell *matHeaderCellDef class="rtalign font12"> {{engLang ? 'Paid': 'Pagado'}} </th>
            <td mat-cell *matCellDef="let clm" class="rtalign font10" (click)="onClick_expandDet(clm.CasID)">
                {{makeNum(clm.totPayed) | currency:'USD':'':'0.2-2'}} </td>
        </ng-container>

        <ng-container matColumnDef="totAbono">
            <th mat-header-cell *matHeaderCellDef class="rtalign font12"> {{engLang ? 'Part Paid': 'Abono'}} </th>
            <td mat-cell *matCellDef="let clm" class="rtalign font10" (click)="onClick_expandDet(clm.CasID)">
                {{makeNum(clm.totAbono) | currency:'USD':'':'0.2-2'}} </td>
        </ng-container>

        <ng-container matColumnDef="pvdoBal">
            <th mat-header-cell *matHeaderCellDef class="rtalign font12">Balance</th>
            <td mat-cell *matCellDef="let clm" class="rtalign font10" (click)="onClick_expandDet(clm.CasID)">
                {{makeNum(clm.pvdoBal) | currency:'USD':'':'0.2-2'}} </td>
        </ng-container>

        <ng-container matColumnDef="footerTotalsPanel">
            <td mat-footer-cell *matFooterCellDef [attr.colspan]="rptDtxDisplydCols.length">
                <div class="footer-totals-panel font12">
                    <div class="footer-col">
                        <div class="d-flex flex-column align-items-center">
                            <div>
                                {{engLang ? 'Register':'Caja'}}{{': '}}
                            </div>
                            <div>
                                {{ dtxTot()?.payedTot ? (makeNum(dtxTot().payedTot) | currency:'USD':'':'0.2-2') : '0'
                                }}
                            </div>
                        </div>
                    </div>
                    <div class="footer-col">
                        <div class="d-flex flex-column align-items-center">
                            <div>
                                {{engLang ? 'Insurances':'Seguros'}}{{': '}}
                            </div>
                            <div>
                                {{ dtxTot()?.insXpectTot ? (makeNum(dtxTot().insXpectTot) | currency:'USD':'':'0.2-2') :
                                '0'
                                }}
                            </div>
                        </div>
                    </div>
                    <div class="footer-col">
                        <div class="d-flex flex-column align-items-center">
                            <div>
                                {{engLang ? 'Patients':'Privado'}}{{': '}}
                            </div>
                            <div>
                                {{ dtxTot()?.pvdoTot ? (makeNum(dtxTot().pvdoTot) | currency:'USD':'':'0.2-2') : '0' }}
                            </div>
                        </div>
                    </div>
                    <div class="footer-col">
                        <div class="d-flex flex-column align-items-center">
                            <div>
                                {{engLang ? 'Instalment':'Abonos'}}{{': '}}
                            </div>
                            <div>
                                {{ dtxTot()?.abonoTot ? (makeNum(dtxTot().abonoTot) | currency:'USD':'':'0.2-2') : '0'
                                }}
                            </div>
                        </div>
                    </div>
                    <div class="footer-col">
                        <div class="d-flex flex-column align-items-center">
                            <div>
                                {{'Cash'}}{{': '}}
                            </div>
                            <div>
                                {{ dtxTot()?.cashTot ? (makeNum(dtxTot().cashTot) | currency:'USD':'':'0.2-2') : '0' }}
                            </div>
                        </div>
                    </div>
                    <div class="footer-col">
                        <div class="d-flex flex-column align-items-center">
                            <div>
                                {{'Cks'}}{{': '}}
                            </div>
                            <div>
                                {{ dtxTot()?.ckTot ? (makeNum(dtxTot().ckTot) | currency:'USD':'':'0.2-2') : '0' }}
                            </div>
                        </div>
                    </div>
                    <div class="footer-col">
                        <div class="d-flex flex-column align-items-center">
                            <div>
                                {{'ATH'}}{{': '}}
                            </div>
                            <div>
                                {{ dtxTot()?.athTot ? (makeNum(dtxTot().athTot) | currency:'USD':'':'0.2-2') : '0' }}
                            </div>
                        </div>
                    </div>
                    <div class="footer-col">
                        <div class="d-flex flex-column align-items-center">
                            <div>
                                {{'CC'}}{{': '}}
                            </div>
                            <div>
                                {{ dtxTot()?.ccTot ? (makeNum(dtxTot().ccTot) | currency:'USD':'':'0.2-2') : '0' }}
                            </div>
                        </div>
                    </div>
                    <div class="footer-col">
                        <div class="d-flex flex-column align-items-center">
                            <div>
                                {{'Corr'}}{{': '}}
                            </div>
                            <div>
                                {{ dtxTot()?.corrTot ? (makeNum(dtxTot().corrTot) | currency:'USD':'':'0.2-2') : '0' }}
                            </div>
                        </div>
                    </div>
                    <div class="footer-col">
                        <div class="d-flex flex-column align-items-center">
                            <div>
                                {{engLang ? 'Other': 'Otro'}}{{': '}}
                            </div>
                            <div>
                                {{ dtxTot()?.othTot ? (makeNum(dtxTot().othTot) | currency:'USD':'':'0.2-2') : '0' }}
                            </div>
                        </div>
                    </div>
                    <div class="footer-col">
                        <div class="d-flex flex-column align-items-center">
                            <div>
                                {{engLang ? 'Claims': 'Casos'}}{{': '}}
                            </div>
                            <div>
                                {{ clm()?.length ?? '0' }}
                            </div>
                        </div>
                    </div>
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="expandDets"> <!-- Expand Details Column -->
            <td mat-cell *matCellDef="let row" [attr.colspan]="rptDtxDisplydCols.length">
                <div *ngIf="showD" class="d-flex justify-content-between">
                    <app-rpt-dtx-detail [detail]="detail" [engLang]="engLang"></app-rpt-dtx-detail>
                    <app-rpt-dtx-payment [payment]="payment" [engLang]="engLang"></app-rpt-dtx-payment>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="rptDtxDisplydCols; sticky: true" class="clm-header-row"></tr>
        <tr mat-row *matRowDef="let row; columns: rptDtxDisplydCols;"
            [ngClass]="row.index % 2 === 0 ? 'clm-even-row' : 'clm-odd-row'">
        </tr>
        <tr mat-row *matRowDef="let row; columns: ['expandDets'];"
            [ngStyle]="{'display': (isExpanded(row) ? '' : 'none')}"
            [ngClass]="row.index % 2 === 0 ? 'clm-even-row' : 'clm-odd-row'">
        </tr>
        <tr mat-footer-row *matFooterRowDef="['footerTotalsPanel']" class="clm-row totals"></tr>
    </table>
</div>

<!-- modal record/case ................................................................................... -->
<ng-template #recordCaseModal let-modal>
    <div class="modal-header p-8" style="background-color: #ecead6;">
        <div>
            Record: <strong>{{ patNmModalHd }}</strong> <br />
            {{ engLang ? 'Claim: ': 'Caso: ' }}{{ casNoModalHd }}
        </div>
        <div>
            <button type="button" class="btn btn-sm btn-close" style="margin-top: -30px;"
                (click)="modal.dismiss('recordCaseModal')"></button>
        </div>
    </div>

    <div class="modal-body" #modalBody>
        <app-record [activeTab]="2" [xtPID]="xtPID" [xtCID]="xtCID" [modalBody]="modalBody"
            (setNewRecordNoEvent)="setNewRecordNo($event)">
        </app-record>
    </div>

    <div class="modal-footer d-sm-inline-flex justify-content-between p-8" style="background-color: #ecead6;">
        <div>
            {{ engLang ? 'Esc - Close': 'Esc - Cerrar'}}
        </div>
        <div>
            <button type="button" class="btn btn-sm btn-outline-dark" *ngIf="!waiting4Response"
                (click)="modal.close('close_recordCaseModal')">{{ engLang ? 'Close': 'Cerrar' }}</button>
        </div>
    </div>

</ng-template>

<!-- <pre> -->
<!-- {{ dataSource?.filteredData | json2 }} -->
<!-- {{parm() | json2}} -->
<!-- {{clm() | json2}} -->
<!-- {{det() | json2}} -->
<!-- {{pay() | json2}} -->
<!-- {{tot() | json2}} -->
<!-- </pre> -->